import React, { FunctionComponent } from 'react'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { Mobile, Desktop } from 'Shared/components/Responsive'
import { IconOrangeAlert } from 'Stories/Icon/Icon.stories'
import { ModalSubHeader } from 'Stories/ModalSubHeader/ModalSubHeader.stories'

import {
  SearchSimilarArtistFormProps,
  FormDataProps,
} from './SimilarArtistSearchFormProps'

import {
  HorizontalLine,
  StyledText,
  MatchingInfoWrapper,
  MatchingInfoContainer,
  MatchingInfoIcon,
  ModalSubHeaderWrapper,
} from './styles'

const SearchSimilarArtistForm: FunctionComponent<SearchSimilarArtistFormProps> = ({
  artists,
  search,
  searchError,
  errorAnswerSpotify,
  onChange,
  onSubmit,
  genresSelectedLength,
}) => {
  const { t } = useTranslation()

  const { register, handleSubmit } = useForm<FormDataProps>({
    mode: 'onChange',
  })

  return (
    <>
      <Desktop>
        <form
          className="theme-light form spotify_url_form"
          // @ts-ignore
          onSubmit={handleSubmit(onSubmit)}
        >
          <div className="form__form-group">
            <div
              className="form__form-group-field"
              style={{ flexDirection: 'column' }}
            >
              <StyledText>
                {t('createCampaignPage.enterSimilarArtist')}
              </StyledText>
              <ModalSubHeaderWrapper>
                <ModalSubHeader
                  content={t('createCampaignPage.findAdditionalGenres')}
                />
              </ModalSubHeaderWrapper>

              <div className="form__form-group-field search__container">
                <input
                  className="form__form-group-field input search__container-input"
                  required
                  autoComplete="off"
                  id="searchArtistInput"
                  // @ts-ignore
                  name="searchArtistInput"
                  type="text"
                  value={search}
                  {...register('searchArtistInput')}
                  onKeyPress={e => {
                    e.key === 'Enter' && e.preventDefault()
                  }}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    //  eslint-disable-next-line @typescript-eslint/no-explicit-any
                    onChange(e.target.value as any)
                  }
                />
                <MatchingInfoWrapper>
                  {searchError && (
                    <MatchingInfoContainer>
                      <MatchingInfoIcon>
                        <IconOrangeAlert />
                      </MatchingInfoIcon>

                      <div>
                        {t(
                          'createCampaignPage.oopsWeHaveAnIssueHerePleaseReloadPage'
                        )}
                      </div>
                    </MatchingInfoContainer>
                  )}

                  {errorAnswerSpotify && (
                    <MatchingInfoContainer>
                      <MatchingInfoIcon>
                        <IconOrangeAlert />
                      </MatchingInfoIcon>

                      <div>
                        {t(
                          'createCampaignPage.sorrySpotifyIsNotRespondingPleaseTryAgainLater'
                        )}
                      </div>
                    </MatchingInfoContainer>
                  )}
                </MatchingInfoWrapper>

                {genresSelectedLength === 0 && (
                  <div className="form__form-group-field_button-block">
                    {(search && search.length === 0) ||
                      (artists && artists.length === 0 && (
                        <button
                          className="btn btn-secondary search-btn"
                          style={{ pointerEvents: 'none' }}
                          disabled
                          type="submit"
                        >
                          {t('createCampaignPage.searchArtist')}
                        </button>
                      ))}
                    {(search && search.length !== 0) ||
                      (artists && artists.length !== 0 && (
                        <button
                          className="btn btn-success search-btn"
                          type="submit"
                        >
                          {t('createCampaignPage.searchArtist')}
                        </button>
                      ))}
                    {artists && artists.length === 1 && <div />}
                  </div>
                )}
              </div>
            </div>
          </div>
        </form>
      </Desktop>
      <Mobile>
        <form
          className="theme-light form spotify_url_form"
          // @ts-ignore
          onSubmit={handleSubmit(onSubmit)}
        >
          <div className="form__form-group">
            <div
              className="form__form-group-field"
              style={{ flexDirection: 'column' }}
            >
              <div className="form__form-group-field search__container">
                <input
                  className="input search__container-input"
                  required
                  autoComplete="off"
                  id="searchArtistInput"
                  // @ts-ignore
                  name="searchArtistInput"
                  type="text"
                  value={search}
                  placeholder={t(
                    'createCampaignPage.enterArtistsNameToFindSimilarGenres'
                  )}
                  {...register('searchArtistInput')}
                  onKeyPress={e => {
                    e.key === 'Enter' && e.preventDefault()
                  }}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    //  eslint-disable-next-line @typescript-eslint/no-explicit-any
                    onChange(e.target.value as any)
                  }
                />
              </div>
            </div>
          </div>
        </form>
        <HorizontalLine />
      </Mobile>
    </>
  )
}
export default SearchSimilarArtistForm
